import OwnerModel from '../owner/owner-model';
import ReportgroupModel from '../reportgroup/reportgroup-model';

export default class TransactiontypeModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    type: string;
    typeCaption: string;
    pricetype: string;
    reportgroup: any;
    reportgroupCaption: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.type = datarow.type || 'general';
        this.typeCaption = TransactiontypeModel.optionType.filter((d: any) => d.name === this.type)?.[0]?.caption || 'General';
        this.pricetype = datarow.pricetype || 'pricebase';
        let reportgroup = datarow.reportgroup?.data? new ReportgroupModel(datarow.reportgroup?.data) : datarow.reportgroup;
        this.reportgroup = reportgroup?.id;
        this.reportgroupCaption = reportgroup?.name;
        
    } 

    public static endPoint: string = 'transaction-types';
    public static endPointFilterList = (type?: string) => {
       const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' + owner + (type? '&filters[type]=' +type : ''));
    } 
    public static url: string = '/transactiontype';
    public static caption: string = 'Transaction Type';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),         
        type: 'general',
        typeCaption: 'General',
        pricetype: 'pricebase',
        reportgroup: null,
        reportgroupCaption: '',
  
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionType = [
        { name: 'general', caption: 'General' },
        { name: 'purchase', caption: 'Purchase' },
        { name: 'sales', caption: 'Sales' },
    ]

    public static optionPricetype = [
        { name: 'pricebase', caption: 'Price Base' },
        { name: 'pricesale', caption: 'Price Sale' },
    ]
}